import { render, staticRenderFns } from "./Digistaff.vue?vue&type=template&id=03e3ef98"
import script from "./Digistaff.vue?vue&type=script&lang=js"
export * from "./Digistaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports